import classNames from 'classnames';
import 'number-to-locale-string';
import React, { forwardRef } from 'react';
import { codes } from '../../data/translations';
import { useTranslationAPI } from '../../modules/translations';
import { isUndefined } from '../../predicates/type';
import { HELLOFLEX_TEXTBOX_CLASS } from './const';
import classes from './styles/index.module.scss';
import { TextBoxProps } from './types';

const Textbox = forwardRef<HTMLInputElement, TextBoxProps>(
	(
		{
			inputClassName,
			invalid,
			dataTestIdField,
			invalidInputClassName = '',
			isOriginalEvent,
			inputRef,
			onChange,
			disabled,
			className,
			size,
			placeholder,
			name,
			type = 'text',
			style,
			autoComplete = 'off',
			enterKeyHint = 'enter',
			...restProps
		},
		ref,
	) => {
		const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			if (disabled) {
				return;
			}

			if (onChange) {
				if (isOriginalEvent) {
					// @ts-ignore
					onChange(e);
				} else {
					onChange(e.target.value);
				}
			}
		};

		const componentClasses = classNames(classes.textbox, HELLOFLEX_TEXTBOX_CLASS, className, {
			[classes.textbox_disabled]: disabled,
			[classes.textbox_small]: size === 'small',
			[classes.textbox_medium]: size === 'medium',
			[classes.textbox_large]: size === 'large',
			[classes.textbox_invalid]: invalid,
		});
		const { translate } = useTranslationAPI();
		const inputPlaceholder = isUndefined(placeholder) ? translate(codes.common.fillIn) : placeholder;

		const inputClassNames = classNames(inputClassName, {
			[invalidInputClassName]: invalid,
		});

		return (
			<div
				className={componentClasses}
				style={style}
			>
				<input
					{...restProps}
					name={name}
					placeholder={inputPlaceholder}
					aria-label={name || 'textbox'}
					data-testid={dataTestIdField}
					onChange={handleInputChange}
					disabled={disabled}
					readOnly={disabled}
					ref={ref || inputRef}
					autoComplete={autoComplete}
					className={inputClassNames}
					type={type}
					enterKeyHint={enterKeyHint}
				/>
			</div>
		);
	},
);

export { Textbox };

Textbox.displayName = 'Textbox';
